var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.65 41.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4f606e;}.cls-2{fill:#659f49;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M825.91,201.43c4.5-2.07,9.13-4.65,14.06-6.36,4.31-1.49,6.45.21,6.55,4.63.17,7.32.33,14.67-.14,22-.13,1.86-2.32,4.07-4.12,5.23-4.26,2.74-9,4.67-13.26,7.48-2.57,1.71-4.06,1.49-6.53-.19a73.37,73.37,0,0,0-13-7c-2.88-1.19-4.46-2.57-4.45-5.7,0-7.15-.09-14.31.05-21.47.09-4.75,2.18-6.48,6.77-4.92C816.67,196.71,821.15,199.24,825.91,201.43Zm.86,30.5c5.19-2.43,10-4.47,14.61-7a5.83,5.83,0,0,0,2.45-4.16c.28-5.64.12-11.31.11-17,0-7.44-1.13-8.26-8-5.31a27.13,27.13,0,0,0-6.81,4.08,7,7,0,0,0-2.3,4.56C826.65,215.47,826.77,223.79,826.77,231.93Zm-1.9,0V209.59a9.39,9.39,0,0,0,0-2.49c-.4-1.37-.65-3.3-1.63-3.9a80.24,80.24,0,0,0-11.42-5.92c-2.37-1-4.15,0-4.1,3.12.1,7-.1,14,.15,21a5.22,5.22,0,0,0,2.48,3.63C814.92,227.44,819.73,229.53,824.87,231.94Z",
    transform: "translate(-805.04 -194.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M826.77,231.93c0-8.14-.12-16.46.11-24.77a7,7,0,0,1,2.3-4.56,27.13,27.13,0,0,1,6.81-4.08c6.82-3,8-2.13,8,5.31,0,5.66.17,11.33-.11,17a5.83,5.83,0,0,1-2.45,4.16C836.79,227.46,832,229.5,826.77,231.93Z",
    transform: "translate(-805.04 -194.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M824.87,231.94c-5.14-2.41-10-4.5-14.56-6.94a5.22,5.22,0,0,1-2.48-3.63c-.25-7-.05-14-.15-21,0-3.12,1.73-4.09,4.1-3.12a80.24,80.24,0,0,1,11.42,5.92c1,.6,1.23,2.53,1.63,3.9a9.39,9.39,0,0,1,0,2.49Z",
    transform: "translate(-805.04 -194.52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/Open.94b5ff57666b2dc600f6c548782c2a87.svg";
export { ForwardRef as ReactComponent };